// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import TourDealForm from '../tour-deal-form';

// ----------------------------------------------------------------------

export default function CreateTourDealView() {
    const settings = useSettingsContext();

    return (
        <Container maxWidth={settings.themeStretch ? false : 'lg'}>
            <CustomBreadcrumbs
                heading="Create Tour Deal"
                links={[
                    {
                        name: 'Dashboard',
                        href: paths.dashboard.driverReview.root,
                    },
                    {
                        name: 'Tour Deals',
                        href: paths.dashboard.affordable.tourDeals,
                    },
                    { name: 'Add Tour Deal' },
                ]}
                sx={{
                    mb: { xs: 3, md: 5 },
                }}
            />
            <TourDealForm />
        </Container>
    );
}

